import { createAction } from '@reduxjs/toolkit'

import { FilterOption } from 'types/GlobalAttributeOptions'

// tryGetAllFilterOptions
export const getAllSuccess = createAction<FilterOption[]>(
  'get_filter_options_success'
)
